import { jsx as s, Fragment as c } from "react/jsx-runtime";
import { useMemo as _ } from "react";
import { ConfigService as i, ApiConfigService as u } from "@nextgen-web-framework/core";
import { useSession as p } from "../Session/SessionProvider.js";
import d from "./registries/userProfileRegistry.js";
const E = () => {
  const t = i.getConfigs();
  return /* @__PURE__ */ s(c, { children: /* @__PURE__ */ s(
    "script",
    {
      "data-testid": "tealium-script",
      "data-pod-name": "fwk",
      dangerouslySetInnerHTML: {
        __html: `
            //   local property to support utag_data updation in SPA
              window.analytics_prev_prop = [];

              // Tealium override to suppress initial page load
              window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
              window.utag_cfg_ovrd.noview = true;
              

              // Tealium integration script
              (function(a,b,c,d) {
                a='https://tags.tiqcdn.com/utag/${t == null ? void 0 : t.NEXT_PUBLIC_TEALIUM_ACCOUNT}/${t == null ? void 0 : t.NEXT_PUBLIC_TEALIUM_PROFILE}/${t == null ? void 0 : t.NEXT_PUBLIC_TEALIUM_ENVIRONMENT}/utag.js';
                b=document;
                c="script";
                d=b.createElement(c);
                d.src=a;
                d.type="text/java"+c;
                d.async=true;
                a=b.getElementsByTagName(c)[0];
                a.parentNode.insertBefore(d,a);
              })();
              `
      }
    }
  ) });
}, l = () => {
  const t = i.getConfigs(), r = u.getTuples(), { session: e, isAnonymous: n } = p();
  return _(() => {
    var o;
    const a = {};
    return n() || (a.visitor_imcID = t.NEXT_PUBLIC_TENANT * 1e11 + Number(e.aboNum ?? 0), a.visitor_partyID = Number(e.partyId ?? 0)), {
      site_country: r["X-Amway-Country"],
      site_currencyCode: t.NEXT_PUBLIC_CURRENCY,
      site_language: (o = r["Accept-Language"]) == null ? void 0 : o.split("-")[0],
      visitor_userProfile: d[e.type ?? "guest"],
      ...a
    };
  }, [
    t.NEXT_PUBLIC_TENANT,
    t.NEXT_PUBLIC_CURRENCY,
    r["X-Amway-Country"],
    r["Accept-Language"],
    e.aboNum,
    e.partyId,
    e.type
  ]);
};
export {
  E as default,
  l as useTealiumDataLayer
};
//# sourceMappingURL=TealiumScript.js.map
